export default __webpack_public_path__ + "static/media/zakaz.f1f7cc21.jpg";